import React, {forwardRef} from 'react'
import Slider, {Settings} from 'react-slick'
import styled from 'styled-components'

const Carousel = forwardRef<Slider, React.PropsWithChildren<Settings>>(
    ({children, ...props}, ref) => {
        const defaultSettings: Settings = {
            autoplaySpeed: 4500,
            dots: true,
            autoplay: true,
            arrows: false,
            pauseOnFocus: true,
            pauseOnDotsHover: true,
            pauseOnHover: true,
        }

        return (
            <Wrapper>
                <Slider ref={ref} {...defaultSettings} {...props}>
                    {children}
                </Slider>
            </Wrapper>
        )
    }
)

const Wrapper = styled.div`
    /* Fixes bug when parent is grid or flex (https://github.com/akiran/react-slick/issues/1320) */
    min-width: 0;

    .slick-slider {
        position: relative;
        display: block;
        user-select: none;

        -webkit-touch-callout: none;
        touch-action: pan-y;
        -webkit-tap-highlight-color: transparent;
    }

    .slick-list {
        position: relative;
        display: block;
        overflow: hidden;
    }

    .slick-list:focus {
        outline: none;
    }

    .slick-list.dragging {
        cursor: pointer;
        cursor: hand;
    }

    .slick-track {
        position: relative;
        top: 0;
        left: 0;

        display: block;
        margin-right: auto;
        margin-left: auto;
    }

    .slick-slider .slick-track,
    .slick-slider .slick-list {
        transform: translate3d(0, 0, 0);
    }

    .slick-track:before,
    .slick-track:after {
        display: table;

        content: '';
    }

    .slick-track:after {
        clear: both;
    }

    .slick-loading .slick-track {
        visibility: hidden;
    }

    .slick-slide {
        display: none;
        float: left;
        height: 100%;
        min-height: 1px;
    }

    .slick-slide img {
        display: block;
    }

    .slick-slide.slick-loading img {
        display: none;
    }

    .slick-slide.dragging img {
        pointer-events: none;
    }

    .slick-initialized .slick-slide {
        display: block;
    }

    .slick-loading .slick-slide {
        visibility: hidden;
    }

    .slick-vertical .slick-slide {
        display: block;

        height: auto;

        border: 1px solid transparent;
    }
`

export default Carousel
